// The one live next-step offer, carried to the answer it belongs to. The
// harness derives it from the projected transcript and the answer's own row
// compares itself against the offer's occurrence id.
import { createContext } from 'react';

import { type NextStepsOffer } from '@apps/web/features/phoebe_chat_v3/model/next_steps';

export type NextStepsOfferValue = NextStepsOffer &
    Readonly<{ readonly onSelect: (prompt: string) => void }>;

export const NextStepsOfferContext = createContext<NextStepsOfferValue | null>(
    null,
);
